<template>
  <section class="cockpit-panel status-panel">
    <div class="cockpit-title">模型运行状态</div>
    <div class="status-grid">
      <div v-for="item in items" :key="item.label" class="status-item">
        <span>{{ item.label }}</span>
        <strong>{{ item.value }}</strong>
      </div>
    </div>
  </section>
</template>

<script setup>
const items = [
  { label: "数据质量", value: "96.2%" },
  { label: "聚类完成率", value: "91.7%" },
  { label: "预警准确率", value: "98.7%" },
  { label: "模型置信度", value: "91.3%" },
  { label: "刷新间隔", value: "15分钟" },
];
</script>

<style lang="less" scoped>
@import "./rightPanelShared.less";

.status-panel {
  padding: 88px 48px 34px;
}

.status-grid {
  height: 100%;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  align-content: center;
  gap: 24px 38px;
  text-align: left;
}

.status-item:last-child {
  grid-column: 1 / 3;
}

.status-item span,
.status-item strong {
  display: block;
  font-weight: 900;
}

.status-item span {
  margin-bottom: 6px;
  color: #ffffff;
  font-size: 23px;
  line-height: 30px;
}

.status-item strong {
  color: #ffffff;
  font-size: 33px;
  line-height: 38px;
  text-shadow: 0 0 10px rgba(255, 255, 255, 0.24);
}

.status-item:nth-child(2) strong,
.status-item:nth-child(4) strong {
  color: #6ffff2;
}

.status-item:last-child {
  display: flex;
  align-items: baseline;
  gap: 12px;
}

.status-item:last-child span,
.status-item:last-child strong {
  display: inline;
  font-size: 23px;
  line-height: 32px;
}
</style>
